<template>
  <v-container id="table-guias" class="pa-0">
    <v-data-table
      :headers="headers"
      :items="list"
      :items-per-page="itemsPerPage"
      :item-class="(item) => item.is_editada==true? 'active' : '' "
      :page.sync="page"
      hide-default-footer
      min="-1"
      max="15"
      ref="guiasListTable"
      class="lotesListTable"
      dense
      @page-count="pageCount = parseInt($event, 10)"
      show-select
      @toggle-select-all="selecionaTodos"
      @item-selected="selecaoUnica"
    >
      <template v-slot:item.selected="{ item }">
        <v-simple-checkbox
          v-model="item.selected"
        ></v-simple-checkbox>
      </template>

      <template v-slot:item.dt_autorizacao="{ item }">
        {{ item.dt_autorizacao | formatDate }}
      </template>

      <template v-slot:item.valor_total="{ item }">
        {{ item.valor_total | formatPrice }}
      </template>

      <template v-slot:item.data-table-update="{ item }">
        <v-btn icon small @click="updateGuia(item.id)">
          <v-icon color="primary" small>fa-pencil-alt</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-col>
      <v-pagination
        class="no-box-shadow"
        v-model="page"
        :length="pageCount"
      ></v-pagination>
    </v-col>
  </v-container>
</template>

<script>
import moment from "moment"
export default {
  data() {
    return {
      headers: [
        { text: "", sortable: false, width: "1px", value: "data-table-select" },
        { text: "Quant. itens", align: "center" ,width: "1px", value: "qtd_itens", sortable: false, },
        { text: "Nº guia prestador", value: "numero_guia_prestador", sortable: false, },
        { text: "Data da autorização.", align: "center" , value: "dt_autorizacao", sortable: false, },
        { text: "Nome beneficiário", value: "nome_beneficiario", sortable: false, },
        { text: "Cart. beneficiário.", value: "carteira_beneficiario", sortable: false, },
        { text: "Valor total (R$)", align: "end" , value: "valor_total", sortable: false },
        { text: "", width: "1px" , sortable: false, value: "data-table-update" },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      selectedGuias: [],
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    selectedGuias(val) {
      this.selectGuias(val)
    }
  },
  methods: {
    selecionaTodos(selection) {
      if (selection.value) {
        this.selectedGuias = [...selection.items];
      } else {
        this.selectedGuias = [];
      }
    },
    selecaoUnica(selection) {
      if (selection.value) {
          this.selectedGuias.push(selection.item);
      } else {
        let ind = this.selectedGuias.findIndex( item => item == selection.item)
        this.selectedGuias.splice(ind, 1)
      }
    },
  },
  props: {
    selectItem: Function,
    formatDate: Function,
    parseDate: Function,
    selectGuias: Function,
    updateGuia: Function,
    getList: Function,
    list: Array
  },
}
</script>

<style lang="scss">
#table-guias {
  .no-box-shadow, .no-box-shadow *{
    box-shadow: 0 0 0 0!important;
  }
  .theme--light.v-data-table.lotesListTable   .v-icon.v-icon {
    font-size: 16px !important;
  }
}
</style>